export class UncaughtApplicationError extends Error {
    constructor(message: string, stack?: string) {
        super(message);
        this.name = 'UncaughtApplicationError';

        // If a stack trace is provided, use it; otherwise, keep the default stack trace.
        if (stack) {
            this.stack = stack;
        }
    }
    public static fromUnknown(error: unknown): Error {
        if (error instanceof Error) {
            // Keep the original error untouched to preserve native metadata for downstream filtering.
            return error;
        }
        if (typeof error === 'string') {
            return new UncaughtApplicationError(error);
        }
        return new UncaughtApplicationError('Unknown error');
    }
}
